import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ProjecaoOfertaMatriculas } from '../../dtos';
import { EtapasEnsino } from '../../enums/etapas-ensino.enum';

interface Etapa {
  codEtapaEnsino: number;
  qtdDiurno: number;
  qtdIntegral: number;
  qtdNoturno: number;
}

@Injectable({
  providedIn: 'root'
})
export class AcessoOfertaEducacionalStateService {
  carregando = new BehaviorSubject<boolean>(true);

  // Padrão Dual-Value: separação entre valores padrão vindos do backend e valores editados
  private projecoesOfertaMatriculasPadrao: ProjecaoOfertaMatriculas[] = [];
  projecoesOfertaMatriculasValores: ProjecaoOfertaMatriculas[] = [];

  private dadosInicializados = false;

  constructor() { }

  // Inicializa dados do backend 
  inicializarDadosDoBackend(projecoes: ProjecaoOfertaMatriculas[]): void {
    if (this.dadosInicializados) {
      console.warn('Dados do backend já foram inicializados. Use setProjecoesOfertaMatriculasValores() para atualizar valores editáveis.');
      return;
    }

    if (!projecoes || !Array.isArray(projecoes)) {
      console.warn('Projeções não está disponível ou não é um array, usando array vazio');
      projecoes = [];
    }

    this.projecoesOfertaMatriculasPadrao = this.normalizarProjecoes(projecoes);
    this.projecoesOfertaMatriculasValores = this.normalizarProjecoes(projecoes);
    this.dadosInicializados = true;
  }

  // Getter para valores padrão
  getProjecoesOfertaMatriculasPadrao(): readonly ProjecaoOfertaMatriculas[] {
    return this.projecoesOfertaMatriculasPadrao;
  }

  // Getters e Setters para valores editados
  setProjecoesOfertaMatriculasValores(projecoes: ProjecaoOfertaMatriculas[]): void {
    if (!projecoes || !Array.isArray(projecoes)) {
      console.warn('Projeções não está disponível ou não é um array, usando array vazio');
      projecoes = [];
    }

    this.projecoesOfertaMatriculasValores = this.normalizarProjecoes(projecoes);
  }

  getProjecoesOfertaMatriculasValores(): ProjecaoOfertaMatriculas[] {
    return this.projecoesOfertaMatriculasValores;
  }

  // Método auxiliar para normalizar as projeções (garante valores padrão)
  private normalizarProjecoes(projecoes: ProjecaoOfertaMatriculas[]): ProjecaoOfertaMatriculas[] {
    return projecoes.map(p => ({
      ...p,
      etapasEnsino: (p.etapasEnsino ?? []).map(e => ({
        ...e,
        numeroMatriculasDiurno: e.numeroMatriculasDiurno ?? 0,
        numeroMatriculasNoturno: e.numeroMatriculasNoturno ?? 0,
        numeroMatriculasIntegral: e.numeroMatriculasIntegral ?? 0,
      }))
    }));
  }

  // Métodos de compatibilidade
  /**
   * @deprecated Use inicializarDadosDoBackend() em vez disso
   */
  setProjecoesOfertaMatriculas(projecoes: ProjecaoOfertaMatriculas[]): void {
    this.inicializarDadosDoBackend(projecoes);
  }

  /**
   * @deprecated Use getProjecoesOfertaMatriculasValores() em vez disso
   */
  getProjecoesOfertaMatriculas(): ProjecaoOfertaMatriculas[] {
    return this.getProjecoesOfertaMatriculasValores();
  }

  /**
   * @deprecated Use setProjecoesOfertaMatriculasValores() com array atualizado
   */
  setProjecaoOfertaMatricula(projecao: ProjecaoOfertaMatriculas): void {
    this.projecoesOfertaMatriculasValores.push(projecao);
  }

  /**
   * @deprecated Use setProjecoesOfertaMatriculasValores() com array atualizado
   */
  updateProjecao(projecao: ProjecaoOfertaMatriculas): void {
    const index = this.projecoesOfertaMatriculasValores.findIndex(p => p.codMec === projecao.codMec);

    if (index !== -1) {
      this.projecoesOfertaMatriculasValores[index] = projecao;
    }
  }

  // Limpa dados de matrícula em memória quando o usuário muda de localização
  limparValoresEditados(): void {
    this.projecoesOfertaMatriculasPadrao = [];
    this.projecoesOfertaMatriculasValores = [];
    this.dadosInicializados = false;
  }
}
